export const GENERIC_NOTIFICATION = {
    name: 'events.generic.notification',
    event: 'events.generic.notification.alerts',
    types: [
        'alerts.order-placed',
        'alerts.error-log',
        'alerts.login',
        'alerts.margin-call',
        'alerts.missed-trade',
        'alerts.package-start',
        'alerts.package-stop',
        'alerts.review-received',
        'alerts.server-down',
        'alerts.server-restart',
        'alerts.signal-triggered',
        'alerts.stop-loss-hit',
        'alerts.strategy-sold',
        'alerts.take-profit-hit',
        'alerts.charting',
        'alerts.expired',
    ]
};